export const SAVE_NETWORK = 'SAVE_NETWORK';
export const SAVE_TECHNOLOGY = 'SAVE_TECHNOLOGY';
export const SAVE_LOCATION = 'SAVE_LOCATION';
export const SAVE_LOCATION_COVERAGE = 'SAVE_LOCATION_COVERAGE';
export const CHANGE_LOCATION_COVERAGE_MODAL_STATE = 'CHANGE_LOCATION_COVERAGE_MODAL_STATE';
export const SAVE_STATIC = 'SAVE_STATIC';
export const SAVE_LEGEND_COLORS = 'SAVE_LEGEND_COLORS';
export const SAVE_DISCLAIMER = 'SAVE_DISCLAIMER';
export const SAVE_FAQ = 'SAVE_FAQ';
export const SAVE_CURRENT_COVERAGE = 'SAVE_CURRENT_COVERAGE';
export const SAVE_BOUNDS = 'SAVE_BOUNDS';
export const SAVE_ZOOM = 'SAVE_ZOOM';



// WEBPACK FOOTER //
// ./src/store/modules/map/mutation-types.js